import { render, staticRenderFns } from "./GiftRecord.vue?vue&type=template&id=ce3d2bba&scoped=true"
import script from "./GiftRecord.vue?vue&type=script&lang=js"
export * from "./GiftRecord.vue?vue&type=script&lang=js"
import style0 from "./GiftRecord.vue?vue&type=style&index=0&id=ce3d2bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3d2bba",
  null
  
)

export default component.exports